import React, {FC} from "react";
import {useTranslation} from "react-i18next";
import UserSessionMenu from "../UserSessionMenu/UserSessionMenu";
import s from "./LoginSessionPanel.module.css";
import {Button, notification} from "@p4ma/p4md-react";
import {useAuthorization} from "../../api/useAuthorization";
import tryParseApiError from "../../../../utils/tryParseApiError";
import {IMPERSONATION_FEATURE_TOGGLE} from "../../../../utils/impersonation";

/**
 * Панель на /login при живой cookie-сессии без access к модулю Auth.
 * Типичный сценарий после Impersonate под обычным пользователем.
 */
const LoginSessionPanel: FC = () => {
  const {t} = useTranslation("common");
  const {signOut, isImpersonating, endImpersonation, loading} = useAuthorization();

  const buttonDisabled = loading.endImpersonation || loading.impersonateUser || loading.signOut;

  const handleEndImpersonation = async () => {
    try {
      notification.info({
        key: "endImpersonation",
        message: t("impersonate.end.loading.message"),
        description: t("impersonate.end.loading.description"),
        duration: 0
      });
      await endImpersonation();
    } catch (error) {
      const description = await tryParseApiError(error);
      notification.error({
        key: "endImpersonationError",
        message: t("impersonate.end.error"),
        description: description ?? undefined
      });
    } finally {
      notification.close("endImpersonation");
    }
  };

  return (
    <div className={s.panel} data-testid="login-session-panel">
      <div className={s.user_menu}>
        <UserSessionMenu />
      </div>
      <p className={s.no_access}>
        {isImpersonating
          ? t("impersonate.session.noModuleAccess")
          : t("messages.userAccessIsNotAllowed")}
      </p>
      {isImpersonating && IMPERSONATION_FEATURE_TOGGLE.endImpersonation ? (
        <Button
          type="ghost"
          onClick={handleEndImpersonation}
          loading={loading.endImpersonation}
          className={s.button}
          disabled={buttonDisabled}
        >
          {t("impersonate.end.action")}
        </Button>
      ) : null}
      <Button
        type="primary"
        onClick={signOut}
        loading={loading.signOut}
        className={s.button}
        disabled={buttonDisabled}
      >
        {t("logout")}
      </Button>
    </div>
  );
};

export default LoginSessionPanel;
